var React = require('react');

function NavIconsExperienceEndpoints (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m14.56 3.48a2.32 2.32 0 0 0 -4.53 0h-4.94v7.25h1.13v-6.15h3.78a2.32 2.32 0 0 0 4.5 0h3.85v16.14h-12.15v-6.18h-1.11v7.28h14.4v-18.34zm-1.12 1.1a1.29 1.29 0 0 1 -2.3 0 1.28 1.28 0 0 1 -.14-.58 1.46 1.46 0 0 1 .11-.52 1.29 1.29 0 0 1 2.37 0 1.24 1.24 0 0 1 .11.52 1.16 1.16 0 0 1 -.15.58zm-4 11.18.73.73 3.83-3.84-3.83-3.84-.73.73 2.56 2.59h-10.51v1h10.51z"}));
}

NavIconsExperienceEndpoints.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsExperienceEndpoints;

NavIconsExperienceEndpoints.default = NavIconsExperienceEndpoints;
